export const TITLE_PAGE = 'Obtén tus productos al instante en la Zona Digital Pichincha';
export const TITLE_NOT_AVAILABLE = 'Venta digital se encuentra en mantenimiento.';
export const TEXT_NOT_AVAILABLE = 'En poco tiempo estaremos disponibles para tí.';

export const enum OutOffice {
  OutOfficeHoursEnd = '06:00:00',
  OutOfficeHoursStart = '22:00:00',
}

export const enum UnHappyPathModal {
  NO_CONFIRM_MODAL = 'NO_CONFIRM_MODAL',
  IDLE_TIMEOUT_MODAL = 'IDLE_TIMEOUT_MODAL',
}

export const enum FooterType {
  DEFAULT = 'DEFAULT',
  HOME = 'HOME',
  LOAN = 'LOAN',
  FTD = 'FTD',
  FTD_CONFIG = 'FTD_CONFIG',
}

export const enum CurrentProductType {
  ACC = 'ACC',
  FTD = 'FTD'
}

export const HOME_SPLASH = 'inicio';

export const LOAN_SPLASH = 'prestamo-personal';

export const FTD_SPLASH = 'plazo-fijo';

export const ACCOUNT_SPLASH = 'abrir-cuenta';

export const ENROLLMENT_SPLASH = 'registro-usuario';

export const urlHome = '#/inicio';

export const ftdUrl = {
  redirection: '#/plazo-fijo/abrir-deposito/redireccion',
  firstPage: '/#/plazo-fijo/abrir-deposito/datos-personales',
};

export const AccUrl = {
  redirection: 'redireccion',
  firstPage: 'abrir-cuenta',
  preferentialPen: '/#/abrir-cuenta/ahorros-4/inicio-apertura',
};

export const FtdUrl = {
  firstPage: '/#/plazo-fijo/abrir-deposito/datos-personales'
}


export const currentProduct = {
  PREFERRED_ACCOUNT : 'Cuenta de Ahorros Preferente'
}

export const urlPublicWeb = {
  DEV: 'http://bancopichinchadev.prod.acquia-sites.com/personas/cuenta/ahorro-preferente',
  CAL: 'https://www.cal.pichincha.pe/personas/cuenta/ahorro-preferente',
  PROD: 'https://www.pichincha.pe/personas/cuenta/ahorro-preferente'
}

export const urlDPFPublicWeb = {
  DEV: 'http://bancopichinchadev.prod.acquia-sites.com/personas/cuenta/deposito-plazo-fijo',
  CAL: 'https://www.cal.pichincha.pe/personas/cuenta/deposito-plazo-fijo',
  PROD: 'https://www.pichincha.pe/personas/cuenta/deposito-plazo-fijo'
}

export const enum ListEnvironments {
    LOCAL = 'localhost',
    DEV = 'dev-zonadigital.pichincha.pe',
    CAL = 'cal-zonadigital.pichincha.pe',
}
